import * as React from "react";
import { connect } from "react-redux";
import GenericInput from "../common/input/GenericInput";
import * as types from "../../constants/actionTypes";
import DataComponent from "../common/DataComponent";
import YesNoModal from "../common/YesNoComponent";
import SectionLoadingError from '../common/SectionLoadingError';
import * as Tools from "../../helpers/Tools";
import { logUI } from '../../api/andyliticsApi';
import ConfirmationModal from '../common/ConfirmationModal';
import Spinner from "../common/spinner";

class LinkEmployeeAccount extends DataComponent {
    constructor(props) {
        super(props);
        this.state = {
            fields: {
                LinkNetworkID: "",
                LinkNetworkPassword: null
            },
            showModal: false,
            modalText: null,
            modalYesFunction: null,
            modalNoFunction: null,
            inInputMode: props.openEmployee ? true : false,
            submitEnabled: false
        };
        this.handleLinkEmployeeAccountClick = this.handleLinkEmployeeAccountClick.bind(this);
        this.handleUnlinkEmployeeAccountClick = this.handleUnlinkEmployeeAccountClick.bind(this);
        this.validateLinkEmployeeInputs = this.validateLinkEmployeeInputs.bind(this);
        this.handleLinkEmployeeAccountClick2 = this.handleLinkEmployeeAccountClick2.bind(this);
        this.cancelModel = this.cancelModel.bind(this);
        this.handleUnlinkEmployeeAccountClick2 = this.handleUnlinkEmployeeAccountClick2.bind(this);
        this.handlePasswordKeyClick = this.handlePasswordKeyClick.bind(this);
        this.toggleInputMode = this.toggleInputMode.bind(this);
        this.inputsChanged = this.inputsChanged.bind(this);
        this.isMobileQueryValue = Tools.isMobileQuery(props.location);
        this.isFromMobile = false;
    }

    componentDidMount() {
        if (super.componentDidMount) { super.componentDidMount(); }
        this.isFromMobile = this.isMobileQueryValue || Tools.getItemFromSessionStorage('isMobile') || this.props.MobileOnQueryString;
        logUI("MBHWeb.UI.LinkEmployeeAccount.ComponentDidMount", new Date(), Tools.getURLPath());
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        const { inInputMode } = this.state;
        if (inInputMode) {
            if ((prevProps.EmployeeID !== this.props.EmployeeID) ||
                (!prevProps.unlinkEmployeeSuccessMessage && this.props.unlinkEmployeeSuccessMessage) ||
                (!prevProps.linkEmployeeSuccessMessage && this.props.linkEmployeeSuccessMessage)) {
                this.setState({ inInputMode: false });  // turn off the edit if an account was just delinked or linked
            }
        }
    }

    inputsChanged() {
        const { submitEnabled } = this.state;
        const bValid = this.validateLinkEmployeeInputs();
        if (bValid && !submitEnabled) {
            this.setState({ submitEnabled: true });
        }
        else if (!bValid && submitEnabled) {
            this.setState({ submitEnabled: false });
        }
    }

    toggleInputMode() {
        const { inInputMode } = this.state;
        this.setState({ inInputMode: !inInputMode }, () => Tools.setFocus('networkId', !inInputMode));
    }

    cancel = () => {
        this.setState({ inInputMode: false, submitEnabled: false, fields: {} });
    }

    handlePasswordKeyClick(e) {
        if (e.key.toLowerCase() === "enter") {
            //  this.handleLinkEmployeeAccountClick();
        }
    }

    handleLinkEmployeeAccountClick() {
        const encodedId = btoa(this.props.UserId);
        const url = `${window.serverData.data.secureAuthUrl}?id=${encodedId}&networkId=${this.state.fields.LinkNetworkID}`;
        const json = { url };
        logUI("MBHWeb.Account.Employee.Link", new Date(), Tools.getURLPath(), JSON.stringify(json));
        window.location.href = url;
        /*const { linkEmployeeAccount } = this.props;
        const { LinkNetworkID, LinkNetworkPassword } = this.state.fields;
        if (this.validateLinkEmployeeInputs()) {
            this.setState({
                showModal: true,
                modalText: "Are you sure you want to link " + LinkNetworkID + "?",
                modalYesFunction: this.handleLinkEmployeeAccountClick2,
                modalNoFunction: this.cancelModel
            });
        }*/
    }

    handleLinkEmployeeAccountClick2() {
        const { linkEmployeeAccount } = this.props;
        const { LinkNetworkID, LinkNetworkPassword } = this.state.fields;
        this.cancelModel();
        logUI("MBHWeb.Account.Employee.Link", new Date(), Tools.getURLPath());
        linkEmployeeAccount(LinkNetworkID, LinkNetworkPassword, this.isFromMobile);
        window.componentChanged = false;

    }

    cancelModel() {
        this.setState({
            showModal: false
        });
    }

    handleUnlinkEmployeeAccountClick() {
        const { EmployeeID } = this.props;
        this.setState({
            showModal: true,
            modalText: "Are you sure you want to unlink " + EmployeeID + "?",
            modalYesFunction: this.handleUnlinkEmployeeAccountClick2,
            modalNoFunction: this.cancelModel
        });
    }

    handleUnlinkEmployeeAccountClick2() {
        const { unlinkEmployeeAccount } = this.props;
        this.cancelModel();
        logUI("MBHWeb.Account.Employee.Unlink", new Date(), Tools.getURLPath());
        unlinkEmployeeAccount(this.isFromMobile);
    }

    validateLinkEmployeeInputs() {
        const { LinkNetworkID, LinkNetworkPassword } = this.state.fields;
        const { linkEmployeeError } = this.props;
        if (Tools.isEmptyString(LinkNetworkID) /*|| Tools.isEmptyString(LinkNetworkPassword)*/) {
            //linkEmployeeError("You must supply a network ID and password!");
            return false;
        }
        return true;
    }

    render() {
        const {
            EmployeeID,
            linkEmployeeFailureMessage,
            linkEmployeeSuccessMessage,
            linkEmployeeInProcess,
            unlinkEmployeeFailureMessage,
            unlinkEmployeeSuccessMessage,
            unlinkEmployeeInProcess,
            isProxyUser
        } = this.props;

        const {
            showModal, modalYesFunction, modalNoFunction, modalText,
            inInputMode, submitEnabled, fields
        } = this.state;

        //debugger;
        if (!this.bHasWindow) {
            console.log("Linked accounts render: EmpID =" + EmployeeID);
        }
        if (isProxyUser) {
            return "";
        }

        return (
            <div className="row">
                <YesNoModal showModal={showModal} modalText={modalText} modalYesFunction={modalYesFunction} modalNoFunction={modalNoFunction} />

                <div className="col-12 list-item-col not-linked">
                    <div className="row align-items-end">
                        <div className="col-12 col-sm-6 col-lg-3">
                            <div className="list-item-col__label">
                                BSWH Employee
                            </div>
                        </div>
                        <div className="col-12 col-sm-6 col-lg-4 text-left text-sm-right text-lg-left">
                            <div className="list-item-col__info">
                                {!EmployeeID
                                    ? <div className="list-item-col__info--unlinked">Not linked</div>
                                    : <div className="list-item-col__info--linked">{EmployeeID} <span className="icon-link" /></div>
                                }
                            </div>
                        </div>
                        <div className="col-12 col-lg-5 text-sm-right">
                            {unlinkEmployeeInProcess || linkEmployeeInProcess
                                ? <Spinner />
                                : EmployeeID && <button type="button" className="list-item-col__action btn btn-link-style" onClick={(e) => this.handleUnlinkEmployeeAccountClick()}>Unlink account</button>
                                /*:
                                UserId &&
                                <div className="list-item-col__action" onClick={(e) => this.handleLinkEmployeeAccountClick(secureAuthUrl)}>Link Account</div>
                                */
                            }
                            {!EmployeeID && !inInputMode &&
                                <div className="list-item-col__action">
                                   <button type="button" className="list-item-col__action--save btn btn-link-style" onClick={this.toggleInputMode}>Link Account</button>
                                </div>
                            }
                        </div>
                    </div>
                    {EmployeeID || !inInputMode ? <div /> :
                        <div className="row edit-mode">
                            <div className="col-12 form-group">
                                <GenericInput id="networkId" name="LinkNetworkID" placeholder="Network ID" pattern={/^[\da-zA-Z]*$/} maxLength="20"
                                    value={fields['LinkNetworkID']} onChange={(e) => this.handleInputChange(e)} required autoComplete="username"
                                />
                            </div>
                            <div className="col-12 form-group form-hint">
                                This is the username that you use when signing into your BSWH devices.
                            </div>
                            {/*<div className="col-12 col-sm-6 form-group">
                                <GenericInput name="LinkNetworkPassword" placeholder="Password" type="Password"
                                    onChange={(e) => this.handleInputChange(e)} onKeyPress={(e) => this.handlePasswordKeyClick(e)} required autoComplete="new-password"
                                />
                            </div>*/}
                        </div>
                    }
                    {inInputMode && <div className="row"><div className="col-12 col-lg-12 text-sm-right">
                        <div className="list-item-col__action">
                            <button type="button" className="list-item-col__action--btn cancel btn" onClick={this.cancel}>Cancel</button>
                            <button type="button" className="list-item-col__action--btn btn" disabled={!submitEnabled} onClick={this.handleLinkEmployeeAccountClick}>Verify and link</button>
                        </div>
                    </div>
                        </div>
                    }
                    <div className="row align-items-end">
                        <div className="col-12">
                            {linkEmployeeFailureMessage && <div className="error-msg" dangerouslySetInnerHTML={linkEmployeeFailureMessage} />}
                            {unlinkEmployeeFailureMessage && <div className="error-msg" dangerouslySetInnerHTML={unlinkEmployeeFailureMessage} />}
                            {!this.isFromMobile && linkEmployeeSuccessMessage && <div className="success-msg">{linkEmployeeSuccessMessage}</div>}
                            {!this.isFromMobile && unlinkEmployeeSuccessMessage && <div className="success-msg">{unlinkEmployeeSuccessMessage}</div>}
                        </div>
                    </div>

                </div>
                <ConfirmationModal when={inInputMode && fields.LinkNetworkID !== ''} />
            </div>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        UserName: state.domain.un,
        EmployeeID: state.domain.ei,
        //EmployeeID: state.memberships.employeeID,               //Getting from memberships profile
        linkEmployeeInProcess: state.healthSource.linkEmployeeInProcess,
        linkEmployeeSuccessMessage: state.healthSource.linkEmployeeSuccessMessage,
        linkEmployeeFailureMessage: state.healthSource.linkEmployeeFailureMessage,
        unlinkEmployeeInProcess: state.healthSource.unlinkEmployeeInProcess,
        unlinkEmployeeSuccessMessage: state.healthSource.unlinkEmployeeSuccessMessage,
        unlinkEmployeeFailureMessage: state.healthSource.unlinkEmployeeFailureMessage,
        isProxyUser: state.domain.ip,
        history: state.session.history,
        token: state.domain.t,
        UserId: state.domain.ui,
        MobileOnQueryString: state.domain.mq
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        linkEmployeeAccount: (lanId, password, isFromMobile) => {
            dispatch({
                type: types.LINK_EMPLOYEE_ACCOUNT_START,
                lanId: lanId,
                password: password,
                isFromMobile
            });
        },
        unlinkEmployeeAccount: (isFromMobile) => {
            dispatch({
                type: types.UNLINK_EMPLOYEE_ACCOUNT_START,
                isFromMobile
            });
        },
        linkEmployeeError: (errorText) => {
            dispatch({
                type: types.LINK_EMPLOYEE_ACCOUNT_FAILURE, errorText: errorText
            });
        }

    };
};

export default connect(mapStateToProps, mapDispatchToProps)(LinkEmployeeAccount);